import React from 'react';
import Tooltip from 'react-tooltip';

function AppTooltip({ id, className = 'app-tooltip', place = 'bottom', children }) {
  return (
    <Tooltip
      id={id}
      className={className}
      place={place}
      effect="solid"
      type="light"
      border={true}
      borderColor="rgba(0,0,0,0.3)"
      html={true}
    >
      {children}
    </Tooltip>
  );
}

export default AppTooltip;
